import React from 'react';
import {
    RadioGroup,
    FormControlLabel,
    Radio,
    Box,
} from '@mui/material';

const OfferSelector = (props) => {

    const { offers, setOffers } = props
    const handleChange = (event) => {
        const selected = event.target.value;
        setOffers({
            buy_one_get_one_free: selected === 'buy_one_get_one_free',
            buy_two_get_one_free: selected === 'buy_two_get_one_free',
            buy_one_get_half_price: selected === 'buy_one_get_half_price',
            none: selected === 'none',
        });
    };

    const radioStyle = {
        color: 'rgb(24, 20, 54)',
        '&.Mui-checked': {
            color: 'rgb(24, 20, 54)',
        },
        '& .MuiSvgIcon-root': {
            fontSize: 20, // 🔧 Adjust this to make the circle smaller
        },
    };

    return (
        <RadioGroup
            name="offers"
            value={
                offers.buy_one_get_one_free
                    ? 'buy_one_get_one_free'
                    : offers.buy_two_get_one_free
                        ? 'buy_two_get_one_free'
                        : offers.buy_one_get_half_price
                            ? 'buy_one_get_half_price'
                            : 'none'
            }
            onChange={handleChange}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                <FormControlLabel
                    value="buy_one_get_one_free"
                    control={<Radio sx={radioStyle} />}
                    label="Buy One Get One Free"
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: '14px', // 🔧 change font size here
                            fontWeight: 500   // optional: add boldness
                        }
                    }}
                />
                <FormControlLabel
                    value="buy_two_get_one_free"
                    control={<Radio sx={radioStyle} />}
                    label="Buy Two Get One Free"
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: '14px', // 🔧 change font size here
                            fontWeight: 500   // optional: add boldness
                        }
                    }}
                />
                <FormControlLabel
                    value="buy_one_get_half_price"
                    control={<Radio sx={radioStyle} />}
                    label="Buy One Get Half Price"
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: '14px', // 🔧 change font size here
                            fontWeight: 500   // optional: add boldness
                        }
                    }}
                />
                <FormControlLabel
                    value="none"
                    control={<Radio sx={radioStyle} />}
                    label="None"
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            fontSize: '14px', // 🔧 change font size here
                            fontWeight: 500   // optional: add boldness
                        }
                    }}
                />
            </Box>
        </RadioGroup>

    );
};

export default OfferSelector;